import React from "react";

import { ScreenFrame } from "components/onboarding/ScreenFrame";

const screenInfo = {
  title: "Olá, eu sou a Alga, sua consultora virtual de energia.",
  body: [
    "Você sabia que eu sou a maior responsável na natureza pela captura de gás carbônico?",
    "Por isso estou aqui para te ajudar na sua trajetória de economia e descarbonização.",
    "Vamos lá?",
  ],
};

const Start = ({ history }) => {
  const handleButtonClick = () => {
    history.push("/onboarding/energy-operator");
  };
  return (
    <ScreenFrame
      body={screenInfo.body}
      buttonText="Próximo"
      title={screenInfo.title}
      variant="success"
      onClick={handleButtonClick}
    />
  );
};

export default Start;
